import React from "react";
import { Image } from "../../../../../components/Image";
import "./style.css";

export const MobileIllustratedOne = ({
    clickNext = () => {},
    clickPrev = () => {},
    value
                            }) => {
  return (
    <div className="illustrated-one-mobile" data-model-id="16762:22307">
      <div className="frame-4">
        <div className="title">
          <p className="text-wrapper">Do you relate to the statement below?</p>
        </div>

        <div className="container">
          <Image src="/static/image/questionnaire/weight-loss/illustratedOne/illustration-1.png" alt="Illustration" className="illustration" />

          <p className="quote">
            I&#39;m struggling to find the right diet plan.
          </p>
        </div>
      </div>

      <div className="container-2">
        <button className={`label-wrapper ${value === "no" && "label-wrapper-select"}`} onClick={() => {clickNext("no")}}>
          <div className="label">No</div>
        </button>

        <button className={`label-wrapper ${value === "yes" && "label-wrapper-select"}`} onClick={() => {clickNext("yes")}}>
          <div className="label-2">Yes</div>
        </button>
      </div>
    </div>
  );
};
